import CategoriesPreview from "../categories-preview/categories-preview.component";

const Shop = () => {
  return <CategoriesPreview />;
};

export default Shop;
